import { styled } from "common/components";

export const Logo = styled("img")(({ theme, width, height }) => ({
  width: width ?? "40px",
  height: height ?? "auto",
  marginRight: theme.spacing(2),
}));
